import { SxProps } from "@mui/material";
import { useMemo } from "react";
import { RegisterOptions } from "react-hook-form";
import { useAppSelector } from "../../../../../app/hooks";
import { TempEmploymentReasonCode } from "../../../../types/TempEmploymentReasonCode";
import { SelectOption } from "../selectField/CommonSelectField";
import SelectField from "../selectField/SelectField";

type Props = {
  name: string;
  fullWidth?: boolean;
  disabled?: boolean;
  inputSx?: SxProps;
  required?: boolean;
  rules?: RegisterOptions;
  error?: boolean;
};

const TempEmploymentReasonField = ({
  name,
  fullWidth = true,
  disabled = false,
  inputSx = {},
  required = false,
  rules,
  error = false,
}: Props) => {
  const tempEmploymentReasons = useAppSelector(
    (state) => state.localized.tempEmploymentReason,
  );

  const options: SelectOption[] = useMemo(() => {
    return Object.values(TempEmploymentReasonCode).map((code) => ({
      value: code,
      label: tempEmploymentReasons[code] || code,
    }));
  }, [tempEmploymentReasons]);

  return (
    <SelectField
      name={name}
      options={options}
      fullWidth={fullWidth}
      disabled={disabled}
      inputSx={inputSx}
      required={required}
      rules={rules}
      error={error}
    />
  );
};

export default TempEmploymentReasonField;
